/**
* @license Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
* For licensing, see LICENSE.md or http://ckeditor.com/license
*/
import PS_BuildReferencesInPaper from '@/services/paper/buildReferencesInPaper';
import PS_SaveDocument from '@/services/paper/saveDocument';
import store from '@/store';

// Save Document (paper body and all it's parts in one)
(() => {
    CKEDITOR.plugins.add('saveDocument', {
		// icons: 'save', // %REMOVE_LINE_CORE%
        hidpi: true, // %REMOVE_LINE_CORE%
        init(editor) {
			store.commit('paperEdit/autoSave/START_TIMER');

            editor.addCommand('saveDocument', {
                exec(editor) {
                    if (editor.fire('saveDocument')) {
                        window.$vm.emitter.emit('setSaveStatusToSaving');
                        
						PS_BuildReferencesInPaper().then(()=>{
							PS_SaveDocument({
								message: 'Saved paper - manual save',
							}).then(()=>{
                                window.$vm.emitter.emit('startPaperSavedTextTimer');
								// window.$vm.emitter.emit('globalToasterOpen',{
								// 	textContent:' Paper changes saved',
								// });
							});//e:PS_SaveDocument
						});//e:PS_BuildReferencesInPaper
                    }
                }//e:exec
            }); // end addCommand save

            editor.ui.addButton('Save', {
				label: 'Save',
                command: 'saveDocument',
            });

            editor.on('destroy', () => {
				store.commit('paperEdit/autoSave/CLEAR_TIMER');
            });

            editor.setKeystroke(CKEDITOR.CTRL + 83 /*S*/, 'saveDocument');
        }//e:init
    });//e:plugins.add

})();